import { x86 } from 'murmurhash3js';
export var drawAbTestVariationForUser = function (userId, abTest) {
    var bucket = (x86.hash32("".concat(userId, "#").concat(abTest.id)) % 100) + 1;
    var acc = 0;
    return {
        bucket: bucket,
        variationId: abTest.variations.find(function (variation) {
            acc += variation.weight;
            return acc >= bucket;
        }).id
    };
};
//# sourceMappingURL=abTest.js.map